export enum ParkingType {
	ParkingZone = 'parkingZone',
	ParkingMachine = 'parkingMachine',
	InfoBox = 'infoBox'
}